import { IconButton } from '@material-ui/core';
import React from 'react';

import { Icon } from '@/components/shared/components/Icon';
import { useScreen } from '@/hooks/useScreen';

export const CartItemDialogClose = ({ onClick }) => {
  const { sm, md } = useScreen();

  const buttonStylesMd: React.CSSProperties = {
    padding: 4,
    position: 'absolute',
    top: 3,
    right: 1,
    marginRight: -8,
  };

  const buttonStylesSm: React.CSSProperties = {
    padding: 4,
    position: 'fixed',
    top: 44,
    right: 38,
    marginRight: 0,
  };

  const buttonStylesXs: React.CSSProperties = {
    padding: 8,
    position: 'fixed',
    top: 18,
    right: 10,
    marginRight: 0,
  };

  return (
    <IconButton onClick={onClick} style={md ? buttonStylesMd : sm ? buttonStylesSm : buttonStylesXs}>
      <Icon size={md ? 24 : 30}>close</Icon>
    </IconButton>
  );
};
